var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "act_search",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9063 15.4008L24.631 21.8244C24.8674 22.0503 25.0001 22.3567 25 22.6761C24.9999 22.9955 24.8669 23.3018 24.6304 23.5276C24.3939 23.7533 24.0731 23.8801 23.7388 23.88C23.4044 23.8799 23.0837 23.7529 22.8474 23.527L16.1227 17.1034C14.1124 18.5907 11.5845 19.2906 9.05317 19.0607C6.52185 18.8308 4.17728 17.6885 2.49642 15.866C0.815558 14.0435 -0.0753278 11.6777 0.00499518 9.25007C0.0853182 6.8224 1.13082 4.51514 2.9288 2.79766C4.72679 1.08018 7.1422 0.081498 9.68366 0.00477151C12.2251 -0.0719549 14.7017 0.77904 16.6097 2.38464C18.5176 3.99023 19.7135 6.22982 19.9542 8.6478C20.1948 11.0658 19.4621 13.4805 17.9051 15.4008H17.9063ZM10.0005 16.7153C11.9895 16.7153 13.8971 15.9606 15.3035 14.6171C16.71 13.2736 17.5001 11.4515 17.5001 9.55149C17.5001 7.65152 16.71 5.82937 15.3035 4.48589C13.8971 3.1424 11.9895 2.38764 10.0005 2.38764C8.01143 2.38764 6.10387 3.1424 4.69741 4.48589C3.29095 5.82937 2.50081 7.65152 2.50081 9.55149C2.50081 11.4515 3.29095 13.2736 4.69741 14.6171C6.10387 15.9606 8.01143 16.7153 10.0005 16.7153Z",
    fill: "#1E3799"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActSearch);
export default __webpack_public_path__ + "static/media/act_search.7db3987f7aacf064bfa4d36c14aad099.svg";
export { ForwardRef as ReactComponent };